import { useForm } from 'react-hook-form';
import CONFIG from '../../constanta/config';
import axios from 'axios';
import { useState } from 'react';
import InputText from '../../components/input/input-text';
import InputSelect from '../../components/input/input-select';
import bg from '../../assets/banner.png';
import InputSelectSearch from '../../components/input/input-select-search';

const PageCheckin = () => {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [status, setStatus] = useState('checkin');

  const [peserta, setPeserta] = useState(null);
  const [nameOptions, setNameOptions] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [inputType, setInputType] = useState(1); // 'qr' or 'manual'

  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();

  const lamaMenginapList = ['0', '1', '2'];

  const handleCancel = () => {
    setStatus('checkin');
    setPeserta(null);
    setMsg('');
  };

  /* =====================================================
   * 1. SEARCH NAMA (API HIT SAAT KETIK)
   * ===================================================== */
  const searchName = async (keyword) => {
    if (!keyword || keyword.length < 3) return;

    setSearchLoading(true);
    try {
      const res = await axios.get(CONFIG.URL_DISDUK + '/peserta/search', {
        params: { name: keyword }
      });

      const options = res.data.data.map((item) => ({
        value: item.qr_code,
        label: item.nama_lengkap
      }));

      setNameOptions(options);
    } catch (err) {
      console.error(err);
    } finally {
      setSearchLoading(false);
    }
  };

  /* =====================================================
   * 2. CHECKIN VIA QR CODE
   * ===================================================== */
  const submitCheckinQR = async (data) => {
    setLoading(true);
    setMsg('');

    try {
      const res = await axios.post(CONFIG.URL_DISDUK + '/cekqr', {
        qr: data
      });

      if (res?.data?.data.length === 0) {
        setMsg('QR Code tidak valid / tidak ditemukan');
        return;
      } else {
        setPeserta(res?.data?.data[0]);
        setStatus('result');
      }
    } catch (err) {
      setMsg('QR Code tidak valid / tidak ditemukan');
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
   * AUTO DETECT SUBMIT
   * ===================================================== */
  const submitForm = (data) => {
    if (inputType === 1 && data.qr_code) {
      submitCheckinQR(data.qr_code);
    } else if (inputType === 2 && data.peserta_id) {
      submitCheckinQR(data.peserta_id);
    } else {
      setMsg('Silakan scan QR atau cari nama peserta');
    }
  };

  /* =====================================================
   * 4. UPDATE LAMA MENGINAP
   * ===================================================== */
  const submitUpdateMenginap = async (data) => {
    setLoading(true);
    setMsg('');

    try {
      const res = await axios.post(CONFIG.URL_DISDUK + '/checkin', {
        peserta_id: peserta.id,
        lama_menginap: parseInt(data.lama_menginap)
      });

      if (res.data.status === 'ERROR') {
        setMsg('Gagal Menyimpan Data');
      } else {
         setShowSuccess(true);
      }
    } catch (err) {
      setMsg('Gagal Menyimpan Data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* SUCCESS MODAL */}
      {showSuccess && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg text-center w-[90%] max-w-sm">
            <p className="text-lg font-semibold mb-4">Data berhasil disimpan</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg">
              OK
            </button>
          </div>
        </div>
      )}

      <div className="w-full flex justify-center px-3 py-8">
        <div className="bg-white w-full max-w-3xl shadow-md rounded-xl p-5">
          <img src={bg} alt="Banner" className="w-full rounded-xl mb-4" />

          {/* ================= CHECKIN ================= */}
          {status === 'checkin' && (
            <>
              <div className="text-2xl font-bold text-center mb-4 underline">
                CHECKIN
              </div>

              <form onSubmit={handleSubmit(submitForm)} className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <InputText
                    onClick={() => setInputType(1)}
                    label="QR Code"
                    name="qr_code"
                    register={register}
                    error={errors.qr_code}
                    autofocus
                    required={false}
                  />

                  <InputSelectSearch
                    onClick={() => setInputType(2)}
                    label="Cari Nama"
                    name="peserta_id"
                    control={control}
                    options={nameOptions}
                    onInputChange={searchName}
                    isLoading={searchLoading}
                    error={errors.peserta_id}
                    required={false}
                  />
                </div>

                {msg && (
                  <p className="text-center text-red-600 font-semibold">
                    {msg}
                  </p>
                )}

                <button
                  disabled={loading}
                  className={`${
                    loading ? 'bg-gray-500' : 'bg-blue-600'
                  } text-white w-full py-3 rounded-lg font-bold`}>
                  {loading ? 'Memproses...' : 'Submit'}
                </button>
              </form>
            </>
          )}

          {/* ================= RESULT ================= */}
          {status === 'result' && peserta && (
            <>
              <div className="text-center mt-6">
                <div className="text-xl">Selamat Datang</div>
                <div className="text-2xl font-bold">{peserta.nama_lengkap}</div>
                <div className="text-lg mb-6">{peserta.asal_instansi}</div>
              </div>

              <form
                onSubmit={handleSubmit(submitUpdateMenginap)}
                className="space-y-4">
                <InputSelect
                  label="Lama Menginap"
                  name="lama_menginap"
                  control={control}
                  options={lamaMenginapList.map((v) => ({
                    value: v,
                    label: `${v}`
                  }))}
                  error={errors.lama_menginap}
                  required
                />

                {msg && (
                  <p className="text-center text-red-600 font-semibold">
                    {msg}
                  </p>
                )}

                <div className="grid grid-cols-2 gap-4">
                  <button
                    type="button"
                    disabled={loading}
                    onClick={() => handleCancel()}
                    className={`${
                      loading ? 'bg-gray-500' : 'bg-red-600'
                    } text-white w-full py-3 rounded-lg font-bold`}>
                    Cancel
                  </button>

                  <button
                    type="submit"
                    disabled={loading}
                    className={`${
                      loading ? 'bg-gray-500' : 'bg-blue-600'
                    } text-white w-full py-3 rounded-lg font-bold`}>
                    {loading ? 'Mengirim...' : 'Submit'}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PageCheckin;
